import React from "react";
import styles from "./Button.module.css";

const Button = ({ color, children, onClick }) => (
  <button
    className={styles.styledButton}
    style={{
      backgroundColor: color || "#2e186a",
      color: color ? "#2E186A" : "#fff",
    }}
    onClick={onClick}
  >
    {children}
  </button>
);

export default Button;
